// Package imports:
import React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons';
// Component imports:
import DisplayBox from '../../DisplayBox/DisplayBox';
import Table from '../../../ui-elements/Table/Table';
import Link from '../../../ui-elements/Link/Link';
// Type imports:
import { IPropertyReport } from '../../../types/PropertyTypes';

interface IProps {
    id?: string,
    eventId?: string,
    propertyReport: IPropertyReport,
    isExample?: boolean
}

const AssetsReportBody: React.FC<IProps> = ({
    id,
    eventId,
    propertyReport,
    isExample
}) => {
    const displayProperties = (type: 'owned' | 'no longer owned') => {
        const filteredProperties = (type === 'owned')
            ? propertyReport.properties.filter(property => property.allowance !== null)
            : propertyReport.properties.filter(property => property.history !== null);
        
        return filteredProperties.map(({
            name,
            description,
            allowance,
            history,
            registry
        }, index) => (
            <div
                className={cx('property-card', { 'first': (index === 0) })}
                key={index}
            >
                <div className='title'>
                    {name}
                </div>
                <div className='information'>
                    <div className='description'>
                        Lýsing:
                        <span>{description}</span>
                    </div>
                    <div className='registry-id'>
                        Fastanúmer:
                        <span>{registry.id}</span>
                    </div>
                </div>
                <Table
                    data={
                        [...((type === 'owned' ? allowance : history) ?? [])]
                        .sort((a, b) => {
                            const aParts = a.properDate.split('.');
                            const bParts = b.properDate.split('.');
                            const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1])-1, parseInt(aParts[0]));
                            const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1])-1, parseInt(bParts[0]));
                            if (aDate < bDate) return -1;
                            if (aDate > bDate) return 1;
                            return 0;
                    })
                    }
                    tableSize='lg'
                    columns={[{
                        title: 'Tegund skjals',
                        textAlign: 'left',
                        dataAccessor: ({ typeName, type }) => typeName ?? type
                    },{
                        title: 'Staða skjals',
                        textAlign: 'left',
                        dataAccessor: ({ statusName, status }) => statusName ?? status
                    },{
                        title: 'Númer skjals',
                        dataAccessor: ({ document }) => document
                    },{
                        title: 'Útgáfudagur',
                        dataAccessor: ({ properDate }) => properDate
                    }]}
                />
            </div>
        ));
    }

    return (
        <DisplayBox
            title='Fasteignir í eigu'
            className='KCL_ViewCompanyAssetsReport'
            asideComponent={
                <div className='report-aside-component'>
                    <div className='link-wrapper'>
                        <FontAwesomeIcon icon={faFilePdf} className="icon-fa" />
                        <Link
                            targetBlank
                            linkSize='15'
                            url={`/Pdf/Properties?ssn=${id}&eventId=${eventId}`}
                            disabled={isExample}
                        >
                            Sækja skýrslu
                        </Link>
                    </div>
                    <div className='date-of-purchase'>
                        Skýrsla keypt: {propertyReport.eventDate}
                    </div>
                </div>
            }
            grayBackground={isExample}
        >
            <div className='main'>
                {displayProperties('owned')}
                {propertyReport.showHistory &&
                    <>
                        <h4 className="middle-h4">Fasteignir ekki lengur í eigu</h4>
                        {displayProperties('no longer owned')}
                    </>
                }
            </div>
        </DisplayBox>
    );
}

export default AssetsReportBody;